import React, { FC } from 'react';
import { JsonLdContent } from '@navi-toolbox/seo';
import { HelmetContext } from '@okapi/helmet-react';
import { RootReducer } from 'store/root-reducer';
import { connect } from 'react-redux';
import { getDisplayedName, getProductMarketingDescription, getProductVideos } from 'features/product-info';
import { transformVideoThumb } from 'utils/transform-video-thumb';
import { VideoObjectJsonLdData } from './types';

export const DATA_QA_VIDEO_OBJECT_JSON_LD = 'pdp-video-object-json-ld';

type Props = {
  context: HelmetContext;
};

export const VideoObjectJsonLd: FC<VideoObjectJsonLdData> = ({ data, context }) => (
  <>
    {data?.map((content) => (
      <JsonLdContent
        content={content}
        dataQa={DATA_QA_VIDEO_OBJECT_JSON_LD}
        context={context}
        key={content.name}
      />
    ))}
  </>
);

export const mapStoreToProps = (store: RootReducer, props: Props): VideoObjectJsonLdData => {
  const name = getDisplayedName(store) || '';
  const description = getProductMarketingDescription(store) || '';
  const videos = getProductVideos(store) || [];
  return {
    data: videos.map(({ url }) => ({
      name,
      description,
      contentUrl: url || '',
      thumbnailUrl: transformVideoThumb(url || ''),
      uploadDate: '2024-01-01T00:00:00',
      isFamilyFriendly: true,
    })),
    context: props.context,
  };
};

export const VideoObjectJsonLdConnected = connect(mapStoreToProps)(VideoObjectJsonLd);
